"use client";
import { Checkbox, Input, Text } from "@softmax/design-system";
import type { RefObject } from "react";
import type { CredentialDialogState } from "./credential-state";
import * as stylex from "@stylexjs/stylex";
import { spacing } from "@softmax/design-system/tokens.stylex";

export function CredentialFields({
  state,
  disabled,
  id,
  input,
  onNameChange,
  onWriteChange,
}: {
  readonly state: Extract<CredentialDialogState, { readonly kind: "create" }>;
  readonly disabled: boolean;
  readonly id: string;
  readonly input: RefObject<HTMLInputElement | null>;
  readonly onNameChange: (name: string) => void;
  readonly onWriteChange: (allowed: boolean) => void;
}) {
  return (
    <>
      <label htmlFor={id} {...stylex.props(styles.field)}>
        Credential name
        <Input
          ref={input}
          id={id}
          required
          maxLength={200}
          value={state.name}
          disabled={disabled}
          onChange={(event) => onNameChange(event.target.value)}
          autoComplete="off"
        />
      </label>
      {state.allowWrite !== undefined ? (
        <Checkbox
          checked={state.allowWrite}
          disabled={disabled}
          onCheckedChange={onWriteChange}
        >
          Allow write access
        </Checkbox>
      ) : null}
      <Text as="p" size="small" tone="muted">
        {state.allowWrite === false
          ? "Read-only access to your account."
          : state.allowWrite === true
            ? "Read and write access to your account."
            : "Access is limited to this player."}
      </Text>
    </>
  );
}

const styles = stylex.create({
  field: { display: "grid", gap: spacing.space8 },
});
